export const styles = (theme) => ({
    listItem: {
        borderRadius: 5,
        padding: theme.spacing(2, 3)
    }
});
